import axios, { AxiosRequestConfig } from "axios";
import { AddressDataResponse } from "./types";

const CEP_API_URL = "https://viacep.com.br/ws";

const api = axios.create({
	baseURL: CEP_API_URL
});

const get = (url: string, config?: AxiosRequestConfig) => api.get<AddressDataResponse>(url, config).then((response) => response.data);

const AddressService = {
	getAddress(cep: string) {
		const sanitizedCep = cep.replace(/\D/g, "");
		return get(`/${sanitizedCep}/json`);
	}
};

export default AddressService;
